<template>
  <router-link class="navbar-brand" to="/">
    <img v-if="config.logoImagePath"
         :src="getImagePath(config.logoImagePath, 'logo')"
         class="navbar-brand" :alt="config.name">
    <span v-else>
    {{ config.name }}
    </span>
  </router-link>
</template>
<script>
import imageMixin from "@/mixins/imageMixin";

export default {
  name: 'top-logo',
  data() {
    return {
      config: window.config
    }
  },
  mixins: [imageMixin]
}
</script>

<style scoped>
.navbar-brand {
  width: 150px;
  margin: 0;
  padding: 0;
}
</style>